/* TODO refactor to headless UI modals for better a11y and more consistent styling */
export function useModalStyles() {
    function addModalStyles(captcha = false) {
        const scrollPosition = window.pageYOffset;

        if (document.documentElement.style.height !== '100vh') {
            document.documentElement.style.height = '100vh';
        }

        if (document.body.style.overflow !== 'hidden') {
            document.body.style.height = '100%';
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';

            if (captcha) {
                document.body.setAttribute('data-position', `-${scrollPosition}px`);
            } else {
                document.body.style.top = `-${scrollPosition}px`;
            }
        }
    }

    function removeModalStyles(captcha = false) {
        let scrollPosition = 0;

        if (captcha) {
            scrollPosition = document.body.getAttribute('data-position');
        } else {
            scrollPosition = document.body.style.top;
        }

        scrollPosition = scrollPosition !== 0 ? parseInt(scrollPosition.substr(1, scrollPosition.length), 10) : 0;

        if (document.documentElement.style.height === '100vh') {
            document.documentElement.style.height = '';
        }

        if (document.body.style.overflow !== 'visible') {
            document.body.style.height = 'auto';
            document.body.style.width = 'auto';
            document.body.style.overflow = 'visible';
            document.body.style.position = 'static';
            if (scrollPosition !== 0) {
                window.scrollTo(0, scrollPosition);
            }
        }
    }

    return {
        addModalStyles,
        removeModalStyles,
    };
}
